export const VIEWER_TOP_OVERLAY_OFFSET = 'calc(var(--safe-top, 0px) + 112px)';
export const VIEWER_TOP_CONTROL_OFFSET =
  'calc(var(--safe-top, 0px) + 112px - var(--viewer-controls-top-shift, 0px))';
export const VIEWER_INLINE_CONTROL_INSET =
  'calc(16px + var(--viewer-controls-inline-shift, 0px))';
export const VIEWER_INFO_PANEL_INLINE_OFFSET =
  'calc(56px + var(--viewer-controls-inline-shift, 0px))';

export const VIEWER_GLASS_SURFACE_STYLE = {
  backgroundColor: 'rgba(84, 84, 84, 0.56)',
  backdropFilter: 'blur(32px)',
  WebkitBackdropFilter: 'blur(32px)',
  boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.08)',
};

export const VIEWER_ICON_BUTTON_STYLE = {
  ...VIEWER_GLASS_SURFACE_STYLE,
  width: 32,
  height: 32,
};
